import { head } from 'lodash';
import store from '@/store';
import { format } from 'date-fns/esm';
const mixins = {
  data () {
    return {
      mapOptions: {
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        clickableIcons: false,
        fullscreenControl: true,
        disableDefaultUi: true
      },

      perfectScrollbarSetting: {
        maxScrollbarLength: 750
      },
      widthClient: 0,

      heightClient: 0
    };
  },

  methods: {
    /**
     * @param {tHeader}: array header corresponding each column in row
     * @param {filterVal} : array key in one object representation in array
     * @param {list}: list to exported
     */
    $exportExcel (tHeader, filterVal, list, filename) {
      import('@/vendor/export-excel')
        .then(excel => {
          const data = this.$formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: filename,
            autoWidth: true,
            bookType: 'xlsx'
          });
        })
        .catch(err => console.log(err));
    },

    /**
     * @param {filterVal} array key
     * @param {jsonData}: json type
     * @result => use in export excel
     *  */
    $formatJson (filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },

    getRandomColor () {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },

    /**
     *
     * @param {oadate} TypeOADate
     */
    // dateFromOADate (oadate) {
    //   var date = new Date((oadate - 25569) * 86400000);
    //   var tz = date.getTimezoneOffset();
    //   return new Date((oadate - 25569 + tz / (60 * 24)) * 86400000);
    // },

    dateFromOADate (oaDate) {
      // Treat integer part is whole days
      var days = parseInt(oaDate);
      // Treat decimal part as part of 24hr day, always +ve
      var ms = Math.abs((oaDate - days) * 86400000);
      // Add days and add ms
      var time = new Date(1899, 11, 30 + days, 0, 0, 0, ms);
      if (time.getMilliseconds() === 999) return new Date(1899, 11, 30 + days, 0, 0, 0, ms + 1);
      else return time;
    },

    formatDate (date) {
      return format(date, 'HH:mm dd/MM/yyyy');
    },

    removeInfoUser () {
      store.dispatch('LOGOUT');
      store.dispatch('REMOVE_INFO_USER');
    },
    /**
     * @param  { [x,y] or [Array[x,y]] }
     * @param  {...list coordinate in data }
     * @result { return round up to nearest largest number }
     * @result { max: 8200 => return 10000 }
     */
    buildRoundNumberAndDistanceAxis (...list) {
      let Arr = [];
      Arr = list.length === 1 ? list[0] : list;
      let separationNumber = '1';
      let maxRound = Math.floor(Math.max(...Arr));
      for (let i = 1; i <= maxRound.toString().length; i++) {
        separationNumber += '0';
      }
      let roundNearestNumber =
        Math.ceil(Math.max(...Arr) / Number(separationNumber)) *
        Number(separationNumber);
      roundNearestNumber /= roundNearestNumber / 2 < Math.max(...Arr) ? 1 : 2;
      return roundNearestNumber || 10;
    },

    mimRoundNumberXAxis (...list) {
      let Arr = [];
      Arr = list.length === 1 ? list[0] : list;
      let separationNumber = '1';
      let minRound = Math.floor(Math.min(...Arr));
      for (let i = 1; i <= Math.abs(minRound).toString().length; i++) {
        separationNumber += '0';
      }
      let roundNearestNumber =
        (minRound / Number(separationNumber)) * Number(separationNumber);
      roundNearestNumber /= roundNearestNumber / 2 > Math.min(...Arr) ? 1 : 2;
      roundNearestNumber = roundNearestNumber > 0 ? 0 : roundNearestNumber;
      return roundNearestNumber;
    },
    /**
     *
     * @param {message} string
     */

    $messageSuccess (message) {
      this.$message({
        showClose: true,
        type: 'success',
        message: message,
        duration: 2000
      });
    },

    $messageError (message) {
      this.$message({
        showClose: true,
        type: 'error',
        message: message,
        duration: 2000
      });
    },

    $messageByArray (errors) {
      let message = [Object.keys(errors)];
      for (let index of message[0]) {
        setTimeout(async () => {
          await this.$messageError(head(errors[index]));
        }, 500);
      }
    },

    $notification (
      message,
      type,
      duration = 2000,
      position = 'top-right',
      showClose = true
    ) {
      this.$notify({
        message: message,
        type: type,
        duration: duration,
        position: position,
        showClose: showClose
      });
    }
  }
};

export default mixins;



// WEBPACK FOOTER //
// ./src/mixins/mixins.js